import ScrollTrigger from '@terwanerik/scrolltrigger';
import easing from 'jquery.easing';

//import Swiper from 'swiper/bundle';
//import Swiper, { Navigation } from 'swiper';
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import lightcase from "lightcase";
import 'lightcase/src/css/lightcase.css';

export class App {
  constructor() {
    //Swiper.use([Navigation])
    this.html = document.documentElement;
    this.body = document.body;
    //this.wrap = document.getElementById('wrap');
    this.home_url = home_url;
    this.tmp_url = tmp_url;
    this.speed = 900;
    this.ease = "easeInOutExpo";
    this.spd = 1000;
    this.judge = 960;


    this.ua = isSp(this);
    this.sp = false;

    //console.log(this.home_url);


    function isSp(_t) {
      let _ua;
      if (navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)) {
        _ua = "mobile";
        _t.makeSp();
        //console.log(_t);
      } else {
        _ua = "other";
      }
      _t.body.classList.add(_ua);
      return _ua;
    }
  }
  init() {
    this.page = document.getElementById('page');
    this.hero = document.getElementById('heroContainer');
    this.header = document.getElementById('masthead');
    this.site_branding = this.header.querySelector('.site-branding');
    this.navContainer = document.querySelector('.navContainer');
    this.menu = document.querySelector('.menu');
    this.item_product = this.menu.querySelectorAll('.item-product');
    this.btn_top = document.getElementById('btn_top');

    this.makeSpParts();
    this.getSize();


    window.addEventListener('load', e => {
      const _this = this;
      
      setTimeout(() => {
        console.log('loaded');
        this.html.classList.add('on');
        this.page.classList.add('on');
        $('.spinner').fadeOut('slow', function () {
          $(this).remove();
        });
        
      }, 700);

      let url = location.href;
      if (url.indexOf('?id=') != -1) {
        let _id = url.split("?id=");
        let _tar = _id[_id.length - 1];
        let _el = document.getElementById(_tar);
        // setTimeout((e) => {
        //   this.anim(_el);
        // }, 100);
        this.anim(_el);
      }

      if (this.body.classList.contains('home')){
        setTimeout(() => {
          // this.hero.querySelector('.swiper').classList.add('on');
          // document.querySelector('.isshi').classList.add('on');
          document.querySelector('.swiper-container').classList.add('on');
        },500);
      }
      // if(this.body.classList.contains('single')){
      //   const iframes = document.querySelectorAll('iframe[src *= "youtube"]');
      // }
      if (this.body.classList.contains('single-product') || 
      this.body.classList.contains('post-type-archive') || 
      this.body.classList.contains('blog')){
        setTimeout(() => {
          console.log('single');
          document.querySelector('.entry-header').classList.add('on');
        },700);
      }
      if (this.body.classList.contains('single-product')){
        setTimeout(() => {
          if(location.hash === '#shoplist'){
            const _tar = document.getElementById('shopList');
            this.anim(_tar);
          }
        },500);
      }
    });

    this.trigger();
    this.events();

    this.resize();

  }
  resize(){
    // console.log('resize');
    this.getSize();
    
    this.html.style.setProperty('--hh', this.headerH+"px");
  }
  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {
            if(trigger.element.classList.contains('tr_img')){
              const _el = trigger.element;
              _el.closest('.point').querySelector('.pt_img').classList.add('on');
            }
            
          },
          out:(trigger) => {

          }
        }
      }
    })
  }
  makeSpParts() {
    console.log('makespparts');
    this.btn_hum = document.createElement('div');
    this.btn_hum.classList.add('btn_hum');
    this.btn_hum.innerHTML = `
    <div class="btn_inner"><span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span></div>`;
    this.site_branding.appendChild(this.btn_hum);
    // console.log(this.btn_hum);
    // console.log('make parts');
  }
  makeSp() {

  }
  getSize() {
    this.winW = window.innerWidth;
    this.headerH = this.header.clientHeight;
    // console.log("w=" + this.winW);
    if (this.winW >= this.judge) {
      this.sp = false;
    } else {
      this.sp = true;
    }
    this.setSize();
  }
  setSize() {
    // console.log('setSize');
    // console.log(this.sp);
    if (this.sp) {
      this.header.classList.add('in');
      this.btn_hum.querySelector('.bar:nth-child(1').style.animationName = "";
      this.btn_hum.querySelector('.bar:nth-child(3)').style.animationName = "";
      //console.log(this.sp);
    } else {
      this.header.classList.remove('in');
      this.header.classList.remove('on');
      //this.menuclose();
      if (this.item_product.length) {
        for (const list_item of this.item_product) {
          const _w = list_item.querySelector('.postWrapper');
          _w.style.maxHeight = "";

          const _btn = list_item.querySelector('.btn_sub');
          //console.log(_btn);
          if (_btn !== null) {
            _btn.classList.remove('on');
          }
          // if(_btn.classList.contains('on')){
          //
          // }

        }
      }
    }
  }
  anim(_t){
    let rect = _t.getBoundingClientRect();

    setTimeout((e) => {

    
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    let targetT = rect.top + scT;
    
    if (this.sp) { targetT = targetT - this.headerH; }
    $('html, body').animate({
      scrollTop:targetT
    },this.spd,this.ease);

  },100);

  }
  events() {

    if(this.body.classList.contains('single-product')){
      const links = document.querySelectorAll('[data-link]');
      this.entryheader = document.querySelector('.entry-header');
      const linkList = document.createElement('ul');
      linkList.classList.add('linkList');
      
      let cnt = 1;
      let _lis = '';
      links.forEach(
        link => {
          let _id = "link"+cnt;
          let _txt = link.dataset.link;
          link.id = _id;
          _lis += `<li class="linkList-item"><a href='#${_id}'>${_txt}</a></li>`;
          cnt++;
          // console.log(link.dataset.link);
        }
      )
      _lis += "<li class='linkList-item'><a href='#shopList'>ショップリスト</a></li>";
      linkList.innerHTML = _lis;
      // console.log(linkList.outerHTML);
      // linkList.outerHTML = `<div class="linkListContainer">${linkList.outerHTML}</div>`;
      this.entryheader.insertAdjacentElement('afterend', linkList);
      //setTimeout(() => {
        const _list = document.querySelector('.linkList');
        _list.outerHTML = `<div class="linkListContainer">${_list.outerHTML}</div>`;

        this.linkListContainer = document.querySelector('.linkListContainer');
        // console.log(_list.outerHTML);
        
      //},100)
    }
    if(this.body.classList.contains('hair_keep_oil')){
      const items = document.querySelectorAll('.itemList-item');
      items.forEach(
        item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            if(item.classList.contains('on')){
              item.classList.remove('on')
            }else{
              item.classList.add('on')
            }
          });
        }
      )
    }
    // console.log('events');
    window.addEventListener('resize',(e)=>{this.resize();});
    //scrol
    const options = {
      root: null,
      rootMargin:"0px 0px",
      threshold: 0
    }
    if(this.sp){
      options.rootMargin = `-${this.headerH}px 0px`;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.target.classList.contains('site-footer')){
          if(entry.intersectionRatio > 0){
            this.btn_top.classList.add('abs');
          }else{
            this.btn_top.classList.remove('abs');
          }
        }
        if(!entry.isIntersecting){
          if(entry.target.classList.contains('jud')){
            this.btn_top.classList.add('on');
            }
          //console.log(entry.target);
          if(this.body.classList.contains('single-product')){
            if(entry.target.classList.contains('entry-header')){
              //console.log('entry');
              this.linkListContainer.classList.add('on');
            }
          }
        }else{
          if(entry.target.classList.contains('jud')){
            this.btn_top.classList.remove('on');
          }

          if(this.body.classList.contains('single-product')){
            if(entry.target.classList.contains('entry-header')){
              // console.log('entry!!');
              this.linkListContainer.classList.remove('on');
            }
          }
        }
      });
    }, options);

    observer.observe(document.querySelector('.jud'));
    observer.observe(document.querySelector('.site-footer'));
    if(this.body.classList.contains('single-product')){
      observer.observe(this.entryheader);
    }

    //atags
    const atags = document.querySelectorAll('a[href^="#"]');
    for(const _a of atags){
      _a.addEventListener('click', e => {
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        if(href == "#" || href == ""){
          href = "#page";
        }
        href = href.replace("#", "");
        const target = document.getElementById(href);
        this.anim(target);
        // setTimeout(e => {
        //   this.anim(target);
        // },100);
      });
    }

    
    if(this.body.classList.contains('single-product')){
      
      // const sub_headers = document.querySelectorAll('.subSec__header');
      const sub_headers = document.querySelectorAll('.subSec_btn_ttl');
      //sub_headers.concat(sub_btns);

      for(const sub_head of sub_headers){
        const _sbtn = document.createElement('div');
        _sbtn.classList.add('sbtn');
        sub_head.classList.add('on');
        sub_head.appendChild(_sbtn);
        const _pa_sub = sub_head.closest('.subSec');

        //console.log(_pa_sub.querySelector('.subInner'));
        if(_pa_sub.querySelector('.subInner') != null){
          //_pa_sub.querySelector('.subSec__container').style.maxHeight = _pa_sub.querySelector('.subInner').clientHeight+"px";

          sub_head.addEventListener('click',(e)=>{
            const _tar = e.currentTarget;
            const pa_sub = _tar.closest('.subSec');
            const tar_box = pa_sub.querySelector('.subSec__container');
            //let _h = 0;
            if(_tar.classList.contains('on')){
              _tar.classList.remove('on');
              //_h = 0;
              $(tar_box).slideUp('slow');
            }else{
              _tar.classList.add('on');
              $(tar_box).slideDown('slow');
              //_h= pa_sub.querySelector('.subInner').clientHeight;
            }
            //tar_box.style.maxHeight = _h + "px";
            // console.log(tar_box);
            // console.log(tar_inner.clientHeight);
          });
        }
      }
    }
    

    if (document.querySelector('.swiper_') != null) {

      const swiper_elm = document.querySelectorAll('.swiper_');
      let swObj = {
        //centeredSlides: true,
        //autoplay: true,
        speed: 1000,
        loop: true,
        loopAdditionalSlides:1,
        // autoplay: {
        //   delay: 3000,
        // },
        slidesToScroll: 1,
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          897: {
            slidesPerView: 1.25,
            centeredSlides: true,
            spaceBetween: 40
          },
          1441: {
            slidesPerView: 1.5,
            centeredSlides: true,
            spaceBetween: 40
          },
          1921: {
            slidesPerView: 1.8,
            centeredSlides: true,
            spaceBetween: 40
          }
        },
        // loopAdditionalSlides: 1,
        // reverseDirection: false,
        navigation: {
          nextEl: '.slider-btn-next',
          prevEl: '.slider-btn-prev',
        }
      };

      let sw_cnt = 0;

      for (const _swip of swiper_elm) {
        _swip.querySelector('.slider').classList.add('sw_' + sw_cnt);
        sw_cnt++;
      }

      let swip_cnt = 0;

      for (const _sw of swiper_elm) {
        if (_sw.classList.contains('media')) {
          swObj.slidesPerView = 1.8,
          swObj.spaceBetween = 40,
          swObj.breakpoints = {
            897: {
              slidesPerView: 3,
              centeredSlides: false,
              spaceBetween: 40
            }
          }
          swObj.navigation = {
            nextEl: '.slider__media-btn-next',
            prevEl: '.slider__media-btn-prev',
          }
        }
        if (_sw.classList.contains('prod')) {
          console.log('prod');
          swObj.slidesPerView = 1;
          swObj.breakpoints = {
            897: {
              slidesPerView: 1,
              centeredSlides: false,
              spaceBetween: 0
            }
          }
          swObj.navigation = {
            nextEl: '',
            prevEl: '',
          }
          swObj.pagination = {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          }
        }
        const cl = ".sw_" + swip_cnt;
        const sw_slider = new Swiper(cl, swObj);

        swip_cnt++;
      }


      //const mainSlider = new Swiper('.slider', swObj);

    }



    const _this = this;
    // window.onpageshow = function (event) {
    //   if (event.persisted) {
    //     console.log('reload');
    //     console.log(_this);
    //   }
    // };



    window.matchMedia("(max-width:897px)").addListener(() => {
      if (window.matchMedia("(min-width:896px)").matches) {
        //console.log('out');
        // this.header.classList.remove('in');
        // this.header.classList.remove('on');
        this.sp = false;
        this.setSize();
      } else {
        // this.header.classList.add('in');
        // console.log(this.sp);
        this.sp = true;
        this.setSize();
      }

    });


    if (this.item_product.length) {
      for (const list_item of this.item_product) {

        const _btn = document.createElement('div');
        _btn.classList.add('btn_sub');
        _btn.classList.add('sp');
        list_item.appendChild(_btn);

        _btn.addEventListener('click', e => {
          const _this = e.currentTarget;
          const _pa = _this.closest('li');
          const _w = _pa.querySelector('.postWrapper');
          let _h = 0;

          if (_this.classList.contains('on')) {
            _this.classList.remove('on');
          } else {
            _this.classList.add('on');
            _h = _pa.querySelector('.postsList').clientHeight;
          }
          _w.style.maxHeight = _h + "px";
        });

        if (this.ua !== "mobile") {

          list_item.addEventListener('mouseover', e => {
            //console.log(this.sp);
            if (this.sp) {
              return false;
            }
            const _w = list_item.querySelector('.postWrapper');
            const listH = list_item.querySelector('.postsList').clientHeight;
            _w.style.maxHeight = listH + "px";
          });
          list_item.addEventListener('mouseout', e => {
            if (this.sp) { return false; }
            const _w = list_item.querySelector('.postWrapper');
            _w.style.maxHeight = 0;
          });

          const items = list_item.querySelectorAll('.postsList-item a');
          for (const _item of items) {
            _item.addEventListener('mouseover', e => {
              _item.classList.remove('col1');
              _item.classList.add('col3');
            });
            _item.addEventListener('mouseout', e => {
              _item.classList.remove('col3');
              _item.classList.add('col1');
            });
          }
        }
      }
    }




    this.btn_hum.addEventListener('click', e => {
      if (this.header.classList.contains('on')) {
        //this.header.classList.remove('on');
        this.menuclose();
      } else {
        //this.header.classList.add('on');
        this.menuopen();
      }
    });


    if (this.body.classList.contains('single-post') || 
    this.body.classList.contains('single-media') || 
    this.body.classList.contains('single-campaign')) {
      const yts = document.querySelectorAll('iframe[src*="youtube"]');
      console.log(yts);
      if (yts.length) {
        for (const yt of yts) {
          yt.outerHTML = `<div class="ytWrapper">${yt.outerHTML}</div>`;
        }
      }
    }

  }
  menuopen() {
    this.header.classList.add('on');
  }
  menuclose() {
    console.log('menuclose');

    this.header.classList.remove('on');

    this.btn_hum.querySelector('.bar:nth-child(1').style.animationName = "bar1";
    this.btn_hum.querySelector('.bar:nth-child(3)').style.animationName = "bar3";

  }
}
